import { useEffect, useState } from "react";
import "./DashboardTap4Content.css";
import { InverterDetail } from "../../../../../../api/Api";
import { Link } from "react-router-dom";

export default function BottomSlider() {
    const [logData, setLogData] = useState([]);
    const [error, setError] = useState(null); // State to store error
    const [loading, setLoading] = useState(true); // State to store loading status

    // Credentials stored in state
    const [credentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        LOC_CODE: sessionStorage.getItem("LCODE") || "",
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        setLoading(true); // Start loading

        try {
            const res = await InverterDetail(credentials);

            if (res?.data && Array.isArray(res.data)) {
                console.log("Fetched Data:", res.data); // Debug fetched data
                setLogData(res.data);
            } else {
                console.error("Data structure mismatch:", res);
                setLogData([]); // Set empty array on data mismatch
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false); // Stop loading after the fetch completes
        }
    };

    useEffect(() => {
        fetchLogData(); // Initial fetch

        // Set interval to refresh data every 10 minutes (600,000 ms)
        const intervalId = setInterval(() => {
            fetchLogData(); // Fetch data every 10 minutes
        }, 30000); // 10 minutes = 600,000 ms

        // Cleanup function to clear interval on component unmount
        return () => clearInterval(intervalId);

    }, []); // Empty dependency array to ensure the effect runs only once

    console.log("logdata", logData);

    // Get the list of offline inverters
    const offlineInverters = logData
        .filter(item => item?.STS === 'Offline')
        .map(item => item?.NAME);

    return (
        <div className="w-100 my-0" style={{backgroundColor:"black"}}>
            <div className="row g-0">
                <div className="col-md-12 w-100 text-center bottomDash" style={{ borderTop: "1px solid #25476A",backgroundColor:"black" }}>

                    <p>
                        <span style={{ float: "left" }}>

                          
                            {/* <button
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: "30px",
                                    background: "linear-gradient(90deg, #4facfe 0%, #00f2fe 100%)", // Gradient background
                                    border: "none", // Clean look without border
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease-in-out",
                                    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = "scale(1.1)"; // Slight zoom on hover
                                    e.target.style.boxShadow = "0 12px 20px rgba(0, 0, 0, 0.3)"; // Enhanced shadow on hover
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = "scale(1)"; // Reset size
                                    e.target.style.boxShadow = "0 8px 15px rgba(0, 0, 0, 0.2)"; // Reset shadow
                                }}
                            >
                                <Link
                                    to="/event-log-reports"
                                    style={{
                                        textDecoration: "none",
                                        color: "white", // Ensure link text matches button text
                                    }}
                                >
                                    Event Log
                                </Link>
                            </button> */}


                        </span>

                        <span style={{ color: "white", fontSize: "16px" }}>Offline :</span>&nbsp;
                        {offlineInverters.length > 0 ? (
                            offlineInverters.map((name, index) => (
                                <span key={index} className="bottomBox mx-2">{name}</span>
                            ))
                        ) : (
                            <span className="bottomBox">No offline inverters</span>
                        )}


                    </p>

                </div>
            </div>  
        </div>
    );
}
